class GoodElevationAIStylist extends HTMLElement {
  connectedCallback() {
    this.endpoint = this.dataset.endpoint || '';
    this.quizUrl = this.dataset.quizUrl || '/pages/quiz-4922';
    this.currency = this.dataset.currency || 'ZAR';
    this.customerSignedIn = this.dataset.customerSignedIn === 'true';
    this.loginUrl = this.dataset.loginUrl || '/account/login';

    this.loading = this.querySelector('[data-ge-loading]');
    this.results = this.querySelector('[data-ge-results]');
    this.error = this.querySelector('[data-ge-error]');
    this.empty = this.querySelector('[data-ge-empty]');
    this.status = this.querySelector('[data-ge-status]');
    this.retryButtons = this.querySelectorAll('[data-ge-retry]');
    this.addButton = this.querySelector('[data-ge-add-look]');
    this.buyNowButton = this.querySelector('[data-ge-buy-now]');
    this.saveButton = this.querySelector('[data-ge-save-look]');
    this.prevButton = this.querySelector('[data-ge-prev-look]');
    this.nextButton = this.querySelector('[data-ge-next-look]');
    this.heroCanvas = this.querySelector('[data-ge-look-hero]');
    this.styleTag = this.querySelector('[data-ge-style-tag]');
    this.anotherButton = this.querySelector('[data-ge-another-look]');
    this.whyButton = this.querySelector('[data-ge-why-look]');
    this.whyPanel = this.querySelector('[data-ge-why-panel]');
    this.updatePreferencesButton = this.querySelector('[data-ge-update-preferences]');
    this.progressRing = this.querySelector('[data-ge-progress-ring]');
    this.progressPercent = this.querySelector('[data-ge-progress-percent]');
    this.progressPercentBar = this.querySelector('[data-ge-progress-percent-bar]');
    this.progressBar = this.querySelector('[data-ge-progress-bar]');
    this.loadingMessage = this.querySelector('[data-ge-loading-message]');
    this.loadingSteps = [...this.querySelectorAll('[data-ge-loading-step]')];
    this.loadingProgressTimer = null;
    this.loadingProgressValue = 10;

    this.retryButtons.forEach((button) =>
      button.addEventListener('click', () => this.loadRecommendation())
    );
    this.addButton?.addEventListener('click', () => this.addCompleteLook(false));
    this.buyNowButton?.addEventListener('click', () => this.addCompleteLook(true));
    this.saveButton?.addEventListener('click', () => this.toggleSaveLook());
    this.prevButton?.addEventListener('click', () => this.changeLook(-1));
    this.nextButton?.addEventListener('click', () => this.changeLook(1));
    this.anotherButton?.addEventListener('click', () => this.changeLook(1));
    this.whyButton?.addEventListener('click', () => this.toggleWhy());
    this.updatePreferencesButton?.addEventListener('click', () => {
      window.location.href = `${this.quizUrl}?update=1`;
    });

    this.looks = [];
    this.currentLookIndex = 0;
    this.restorePendingSavedLook();
    this.loadRecommendation();
  }

  readProfile() {
    const query = new URLSearchParams(window.location.search);
    const stored =
      window.localStorage.getItem('goodElevationStyleDNA') ||
      window.sessionStorage.getItem('goodElevationStyleDNA');

    let profile = {};
    if (stored) {
      try {
        profile = JSON.parse(stored);
      } catch (_) {
        profile = {};
      }
    }

    const fields = [
      'style', 'budget', 'gender', 'size', 'topSize', 'bottomSize',
      'shoeSize', 'shoe_size', 'body_shape', 'colours', 'colors',
      'colourPreference', 'occasion', 'fitPreference', 'shirtFit',
      'pantFit', 'fabrics', 'preferredBrands'
    ];

    fields.forEach((field) => {
      if (!query.has(field)) return;
      const raw = query.get(field);
      if (field === 'preferredBrands' || field === 'colours' || field === 'colors') {
        profile[field] = raw.split(',').map((x) => x.trim()).filter(Boolean);
      } else {
        profile[field] = raw;
      }
    });

    if (Array.isArray(profile.preferredBrands)) {
      profile.preferredBrands = profile.preferredBrands.slice(0, 3);
    }

    profile.preferences = { ...(profile.preferences || {}), preferredJeansBrands: profile.preferredJeansBrands || [], preferredSneakerBrands: profile.preferredSneakerBrands || [] };

    profile.quiz_id = query.get('quiz_id') || profile.quiz_id || '4922';
    profile.response_id = query.get('response_id') || profile.response_id || '';
    profile.locale = document.documentElement.lang || 'en';
    return profile;
  }

  readCustomer() {
    try {
      const customer = JSON.parse(
        window.localStorage.getItem('goodElevationCustomerProfile') || '{}'
      );
      return {
        name: String(customer.name || '').trim().slice(0, 120),
        email: String(customer.email || '').trim().slice(0, 254)
      };
    } catch (_) {
      return { name: '', email: '' };
    }
  }

  show(name) {
    ['loading', 'results', 'error', 'empty'].forEach((key) => {
      if (this[key]) this[key].hidden = key !== name;
    });
  }

  setLoadingProgress(value) {
    const progress = Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
    this.loadingProgressValue = progress;
    if (this.progressRing) {
      this.progressRing.style.setProperty('--ge-progress', progress);
      this.progressRing.closest('.ge-ai__loader-ring')?.style.setProperty('--ge-progress', progress);
    }
    if (this.progressPercent) this.progressPercent.textContent = `${progress}%`;
    if (this.progressPercentBar) this.progressPercentBar.textContent = `${progress}%`;
    if (this.progressBar) this.progressBar.style.width = `${progress}%`;

    const activeIndex = progress >= 92 ? 3 : progress >= 66 ? 2 : progress >= 34 ? 1 : 0;
    const messages = [
      'Understanding your Style DNA',
      'Finding pieces within your budget',
      'Matching your colours and fit',
      'Finalising your complete looks'
    ];
    if (this.loadingMessage && this.loadingMessage.textContent !== messages[activeIndex]) {
      this.loadingMessage.classList.remove('is-visible');
      window.setTimeout(() => {
        if (!this.loadingMessage) return;
        this.loadingMessage.textContent = messages[activeIndex];
        this.loadingMessage.classList.add('is-visible');
      }, 140);
    } else if (this.loadingMessage) {
      this.loadingMessage.classList.add('is-visible');
    }
    this.loadingSteps.forEach((step, index) => {
      step.classList.toggle('is-active', index === activeIndex);
      step.classList.toggle('is-complete', index < activeIndex);
      const icon = step.querySelector('.ge-ai__loading-step-icon');
      if (icon) {
        if (!icon.dataset.originalIcon) icon.dataset.originalIcon = icon.textContent;
        icon.textContent = index < activeIndex ? '✓' : icon.dataset.originalIcon;
      }
    });
  }

  startLoadingProgress() {
    window.clearInterval(this.loadingProgressTimer);
    this.setLoadingProgress(10);
    const targets = [16, 24, 34, 45, 56, 66, 74, 81, 87, 91, 94];
    let index = 0;
    this.loadingProgressTimer = window.setInterval(() => {
      if (index >= targets.length) {
        window.clearInterval(this.loadingProgressTimer);
        return;
      }
      this.setLoadingProgress(targets[index++]);
    }, 650);
  }

  async finishLoadingProgress() {
    window.clearInterval(this.loadingProgressTimer);
    this.setLoadingProgress(100);
    await new Promise((resolve) => window.setTimeout(resolve, 300));
  }

  async loadRecommendation() {
    if (!this.endpoint) {
      this.show('empty');
      return;
    }

    this.show('loading');
    this.startLoadingProgress();
    this.setStatus('');
    window.GoodElevationAnalytics?.track('recommendation_requested', {});

    try {
      const response = await fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          profile: this.readProfile(),
          customer: this.readCustomer()
        })
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data?.error || `Recommendation request failed (${response.status})`);
      }

      if (!data || !Array.isArray(data.looks) || data.looks.length !== 5) {
        throw new Error('The recommendation did not contain three complete looks.');
      }

      this.looks = data.looks;
      this.styleDNA = data.styleDNA || {};
      this.overallHeadline = data.headline || '';
      this.overallExplanation = data.explanation || '';
      this.currentLookIndex = 0;
      window.GoodElevationAnalytics?.track('recommendation_generated', {
        look_count: data.looks.length,
        headline: data.headline || ''
      });
      await this.renderCurrentLook();
      await this.finishLoadingProgress();
      this.show('results');
    } catch (error) {
      window.GoodElevationAnalytics?.track('recommendation_failed', { message: error?.message || 'Unknown error' });
      window.clearInterval(this.loadingProgressTimer);
      console.error('[Good Elevation AI]', error);
      this.show('error');
    }
  }

  async changeLook(direction) {
    if (!this.looks.length) return;
    this.currentLookIndex =
      (this.currentLookIndex + direction + this.looks.length) % this.looks.length;
    await this.renderCurrentLook();
  }

  async renderCurrentLook() {
    const look = this.looks[this.currentLookIndex];
    if (!look) return;

    const products = Array.isArray(look.products) ? look.products : [];
    this.products = products;
    window.GoodElevationAnalytics?.track('look_viewed', {
      look_index: this.currentLookIndex + 1,
      title: look.title || '',
      product_ids: products.map(product => product.variant_id).filter(Boolean)
    });

    const counter = this.querySelector('[data-ge-look-counter]');
    const title = this.querySelector('[data-ge-look-title]');
    const description = this.querySelector('[data-ge-look-description]');
    const brands = this.querySelector('[data-ge-look-brands]');
    const itemList = this.querySelector('[data-ge-look-items]');
    const total = this.querySelector('[data-ge-total]');
    const cartTotal = this.querySelector('[data-ge-cart-total]');
    const pieceLabel = this.querySelector('[data-ge-piece-label]');

    if (counter) {
      counter.textContent = `RECOMMENDED LOOK ${this.currentLookIndex + 1} OF ${this.looks.length}`;
    }
    if (title) {
      title.textContent = look.title || `Good Elevation Look ${this.currentLookIndex + 1}`;
    }
    if (description) {
      description.textContent =
        look.explanation ||
        this.overallExplanation ||
        'A complete outfit curated around your Style DNA.';
    }

    if (this.styleTag) {
      const label = this.styleDNA?.style || this.readProfile().style || 'GOOD ELEVATION';
      this.styleTag.textContent = String(label).toUpperCase();
    }

    if (this.whyPanel) {
      this.whyPanel.hidden = false;
      const profile = this.readProfile();
      const reasons = [];
      if (profile.style || this.styleDNA?.style) reasons.push(`Matches your ${profile.style || this.styleDNA.style} preference`);
      if (profile.colourPreference || profile.colours || profile.colors) reasons.push('Works with your preferred colour palette');
      if (profile.fitPreference || profile.shirtFit || profile.pantFit) reasons.push('Selected around your preferred fit');
      if (profile.budget) reasons.push(`Keeps the complete look within your selected budget where stock allows`);
      const explanation = look.explanation || this.overallExplanation || 'Selected around your Style DNA and available sizes.';
      this.whyPanel.innerHTML = `<strong>Why this works for you</strong><p>${this.escape(explanation)}</p>${reasons.length ? `<ul>${reasons.slice(0,4).map((reason) => `<li>${this.escape(reason)}</li>`).join('')}</ul>` : ''}`;
    }
    if (this.whyButton) this.whyButton.setAttribute('aria-expanded', 'true');

    const uniqueBrands = [
      ...new Set(products.map((p) => p.brand || p.vendor || '').filter(Boolean))
    ];
    if (brands) {
      brands.textContent = uniqueBrands.length
        ? uniqueBrands.join('  •  ')
        : 'GOOD ELEVATION CURATION';
    }

    if (pieceLabel) {
      pieceLabel.textContent = 'YOUR LOOK';
    }

    if (itemList) {
      itemList.replaceChildren(...products.map((product) => this.productRow(product)));
    }

    const totalAmount =
      Number(look.total) ||
      products.reduce((sum, product) => sum + this.priceAmount(product), 0);

    const cartAmount = totalAmount;

    if (total) total.textContent = this.formatMoney(totalAmount);
    if (cartTotal) cartTotal.textContent = this.formatMoney(cartAmount);

    const unavailable = products.length < 1 || !Number(products[0]?.variant_id);
    if (this.addButton) this.addButton.disabled = unavailable;
    if (this.buyNowButton) this.buyNowButton.disabled = unavailable;

    this.updateSaveButton();
    this.renderCompleteOutfitImage(products);
  }

  renderCompleteOutfitImage(products) {
    if (!this.heroCanvas) return;
    const product = Array.isArray(products) ? products[0] : null;
    const imageUrl = this.safeUrl(product?.image || product?.image_url || '', true);
    if (this.heroCanvas.tagName === 'IMG') {
      this.heroCanvas.src = imageUrl === '#' ? '' : imageUrl;
      this.heroCanvas.alt = product?.image_alt || product?.title || 'Good Elevation complete outfit';
      this.heroCanvas.hidden = !product || imageUrl === '#';
      return;
    }
    // Backward-compatible fallback for older markup.
    this.renderHeroComposite(products);
  }

  productRow(product) {
    const row = document.createElement('article');
    row.className = 'ge-look-item';
    const safeImage = this.safeUrl(product.image || '', true);
    const safeLink = this.safeUrl(product.url || product.product_url || '#');
    const colour = this.readColour(product);
    const description = product.description || product.reason || product.explanation || colour || '';

    row.innerHTML = `
      <a class="ge-look-item__thumb" ${safeLink !== '#' ? `href="${this.escape(safeLink)}"` : ''}>
        <img src="${this.escape(safeImage)}" alt="${this.escape(product.image_alt || product.title || '')}" loading="lazy" width="150" height="150">
      </a>
      <span class="ge-look-item__check" aria-hidden="true">✓</span>
      <div class="ge-look-item__copy">
        <h3>${this.escape(product.title || 'Selected item')}</h3>
        ${description ? `<p>${this.escape(description)}</p>` : ''}
      </div>
      <strong class="ge-look-item__price">${this.escape(this.productPrice(product))}</strong>
    `;

    return row;
  }

  readColour(product) {
    const title = String(product.variant_title || product.variant || '').trim();
    if (!title || title.toLowerCase() === 'default title') return '';
    const parts = title.split('/').map((x) => x.trim()).filter(Boolean);
    return parts.length ? parts[0] : '';
  }

  async renderHeroComposite(products) {
    if (!this.heroCanvas) return;

    const canvas = this.heroCanvas;
    const ctx = canvas.getContext('2d');
    const scale = Math.min(window.devicePixelRatio || 1, 2);
    const width = 1000;
    const height = 820;

    canvas.width = width * scale;
    canvas.height = height * scale;
    canvas.style.aspectRatio = `${width} / ${height}`;
    ctx.setTransform(scale, 0, 0, scale, 0, 0);

    // One consistent editorial background for the whole outfit.
    const gradient = ctx.createLinearGradient(0, 0, width, height);
    gradient.addColorStop(0, '#f8ecdc');
    gradient.addColorStop(.55, '#f5eadc');
    gradient.addColorStop(1, '#f1e4d3');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);

    const loaded = await Promise.all(
      products.map((product) => this.loadImage(product.image || product.image_url || ''))
    );

    const prepared = await Promise.all(
      loaded.map((image) => image ? this.prepareCutout(image) : null)
    );

    const items = products.map((product, index) => ({
      product,
      image: prepared[index] || loaded[index],
      role: String(product.role || '').toLowerCase()
    }));

    const byRole = (role) => items.find((x) => x.role === role && x.image);
    const top = byRole('top') || byRole('layer') || items.find((x) => x.image);
    const bottom = byRole('bottom') || items.find((x) => x !== top && x.image);
    const shoes = byRole('shoes') || items.find((x) => x !== top && x !== bottom && x.image);
    const extra = items.find((x) => x !== top && x !== bottom && x !== shoes && x.image);

    if (items.filter((x) => x.image).length <= 3) {
      // Approved 3-piece editorial composition. No duplicated garment sections,
      // no floating cards, and no artificial trouser fold fragments.
      this.drawHeroItem(ctx, top?.image, {
        x: 88, y: 72, w: 430, h: 330, rotate: 0
      });

      this.drawBottomEditorial(ctx, bottom?.image, {
        x: 530, y: 88, w: 300, h: 520, rotate: 0
      });

      this.drawHeroItem(ctx, shoes?.image, {
        x: 145, y: 485, w: 365, h: 235, rotate: 0
      });
    } else {
      // Four-piece layout follows the same disciplined grid.
      this.drawHeroItem(ctx, top?.image, {
        x: 85, y: 55, w: 350, h: 245, rotate: 0
      });
      this.drawBottomEditorial(ctx, bottom?.image, {
        x: 90, y: 300, w: 345, h: 345, rotate: 0
      });
      this.drawHeroItem(ctx, extra?.image, {
        x: 575, y: 80, w: 270, h: 195, rotate: 0
      });
      this.drawHeroItem(ctx, shoes?.image, {
        x: 565, y: 455, w: 285, h: 170, rotate: 0
      });
    }

    // Very subtle floor shadow anchors the whole look without creating separate cards.
    const floor = ctx.createRadialGradient(width * .48, height * .87, 10, width * .48, height * .87, 440);
    floor.addColorStop(0, 'rgba(91,72,48,.055)');
    floor.addColorStop(1, 'rgba(91,72,48,0)');
    ctx.fillStyle = floor;
    ctx.fillRect(40, height * .72, width - 80, height * .24);
  }

  async prepareCutout(image) {
    // Removes only border-connected, near-uniform backgrounds. This makes Shopify
    // product images sit on one shared Good Elevation background instead of looking
    // like separate pasted image cards. If CORS blocks pixel access, the original
    // image is returned and the recommendation still works.
    try {
      const iw = image.naturalWidth || image.width;
      const ih = image.naturalHeight || image.height;
      if (!iw || !ih) return image;

      const maxSide = 900;
      const ratio = Math.min(1, maxSide / Math.max(iw, ih));
      const w = Math.max(1, Math.round(iw * ratio));
      const h = Math.max(1, Math.round(ih * ratio));

      const work = document.createElement('canvas');
      work.width = w;
      work.height = h;
      const wctx = work.getContext('2d', { willReadFrequently: true });
      wctx.drawImage(image, 0, 0, w, h);

      const imageData = wctx.getImageData(0, 0, w, h);
      const data = imageData.data;
      const idx = (x, y) => (y * w + x) * 4;

      const corners = [
        [2, 2], [w - 3, 2], [2, h - 3], [w - 3, h - 3]
      ];
      const bg = [0, 1, 2].map((c) =>
        corners.reduce((sum, [x, y]) => sum + data[idx(x, y) + c], 0) / corners.length
      );

      const distance = (i) => {
        const dr = data[i] - bg[0];
        const dg = data[i + 1] - bg[1];
        const db = data[i + 2] - bg[2];
        return Math.sqrt(dr * dr + dg * dg + db * db);
      };

      const visited = new Uint8Array(w * h);
      const queue = new Int32Array(w * h);
      let head = 0;
      let tail = 0;
      const push = (x, y) => {
        if (x < 0 || y < 0 || x >= w || y >= h) return;
        const pos = y * w + x;
        if (visited[pos]) return;
        const i = pos * 4;
        if (distance(i) > 52) return;
        visited[pos] = 1;
        queue[tail++] = pos;
      };

      for (let x = 0; x < w; x++) {
        push(x, 0);
        push(x, h - 1);
      }
      for (let y = 0; y < h; y++) {
        push(0, y);
        push(w - 1, y);
      }

      while (head < tail) {
        const pos = queue[head++];
        const x = pos % w;
        const y = Math.floor(pos / w);
        const i = pos * 4;
        const d = distance(i);
        data[i + 3] = d < 32 ? 0 : Math.round(255 * Math.max(0, Math.min(1, (d - 32) / 20)));
        push(x + 1, y);
        push(x - 1, y);
        push(x, y + 1);
        push(x, y - 1);
      }

      wctx.putImageData(imageData, 0, 0);
      return this.cropTransparent(work);
    } catch (_) {
      return image;
    }
  }

  cropTransparent(source) {
    try {
      const ctx = source.getContext('2d', { willReadFrequently: true });
      const w = source.width;
      const h = source.height;
      const data = ctx.getImageData(0, 0, w, h).data;
      let minX = w, minY = h, maxX = -1, maxY = -1;
      for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
          if (data[(y * w + x) * 4 + 3] > 12) {
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
          }
        }
      }
      if (maxX < minX || maxY < minY) return source;
      const pad = Math.max(4, Math.round(Math.min(w, h) * .02));
      minX = Math.max(0, minX - pad);
      minY = Math.max(0, minY - pad);
      maxX = Math.min(w - 1, maxX + pad);
      maxY = Math.min(h - 1, maxY + pad);

      const out = document.createElement('canvas');
      out.width = maxX - minX + 1;
      out.height = maxY - minY + 1;
      out.getContext('2d').drawImage(
        source,
        minX, minY, out.width, out.height,
        0, 0, out.width, out.height
      );
      return out;
    } catch (_) {
      return source;
    }
  }

  drawHeroItem(ctx, image, box) {
    if (!image) return;
    const { x, y, w, h, rotate = 0 } = box;

    ctx.save();
    ctx.translate(x + w / 2, y + h / 2);
    ctx.rotate(rotate);
    ctx.shadowColor = 'rgba(41, 31, 20, .11)';
    ctx.shadowBlur = 18;
    ctx.shadowOffsetY = 8;

    const iw = image.naturalWidth || image.width;
    const ih = image.naturalHeight || image.height;
    const containScale = Math.min(w / iw, h / ih);
    const dw = iw * containScale;
    const dh = ih * containScale;

    ctx.drawImage(image, -dw / 2, -dh / 2, dw, dh);
    ctx.restore();
  }

  drawBottomEditorial(ctx, image, box) {
    if (!image) return;
    const { x, y, w, h, rotate = 0 } = box;
    const iw = image.naturalWidth || image.width;
    const ih = image.naturalHeight || image.height;
    if (!iw || !ih) return;

    ctx.save();
    ctx.translate(x + w / 2, y + h / 2);
    ctx.rotate(rotate);
    ctx.shadowColor = 'rgba(41, 31, 20, .10)';
    ctx.shadowBlur = 17;
    ctx.shadowOffsetY = 8;

    // Keep the trouser as one coherent garment. Fit it slightly shorter than
    // the available area so it reads like a neatly arranged flat-lay rather
    // than a stretched catalogue cutout.
    const scale = Math.min((w * .92) / iw, (h * .92) / ih);
    const dw = iw * scale;
    const dh = ih * scale;
    ctx.drawImage(image, -dw / 2, -dh / 2, dw, dh);
    ctx.restore();
  }

  loadImage(url) {
    return new Promise((resolve) => {
      const safe = this.safeUrl(url, true);
      if (safe === '#') return resolve(null);

      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = () => resolve(img);
      img.onerror = () => {
        const fallback = new Image();
        fallback.onload = () => resolve(fallback);
        fallback.onerror = () => resolve(null);
        fallback.src = safe;
      };
      img.src = safe;
    });
  }

  savedLooks() {
    try {
      return JSON.parse(localStorage.getItem('goodElevationSavedLooks') || '[]');
    } catch (_) {
      return [];
    }
  }

  lookKey(look = this.looks[this.currentLookIndex]) {
    const ids = (look?.products || []).map((p) => p.variant_id).filter(Boolean).join('-');
    return ids || `${look?.title || 'look'}-${this.currentLookIndex}`;
  }

  toggleSaveLook() {
    const look = this.looks[this.currentLookIndex];
    if (!look) return;

    if (!this.customerSignedIn) {
      try {
        localStorage.setItem('goodElevationPendingSavedLook', JSON.stringify({
          key: this.lookKey(look),
          look,
          savedAt: new Date().toISOString()
        }));
      } catch (_) {}
      this.showSaveLoginPrompt();
      return;
    }

    const key = this.lookKey(look);
    const saved = this.savedLooks();
    const index = saved.findIndex((entry) => entry.key === key);

    if (index >= 0) {
      saved.splice(index, 1);
      this.setStatus('Look removed from your favourites.');
      window.GoodElevationAnalytics?.track('look_unsaved', { look_index: this.currentLookIndex + 1, key });
    } else {
      saved.push({ key, look, savedAt: new Date().toISOString() });
      this.setStatus('Look saved to your favourites.');
      window.GoodElevationAnalytics?.track('look_saved', { look_index: this.currentLookIndex + 1, key });
    }

    localStorage.setItem('goodElevationSavedLooks', JSON.stringify(saved.slice(-30)));
    document.dispatchEvent(new CustomEvent('goodElevationSavedLooksChanged'));
    this.updateSaveButton();
  }

  restorePendingSavedLook() {
    if (!this.customerSignedIn) return;
    try {
      const raw = localStorage.getItem('goodElevationPendingSavedLook');
      if (!raw) return;
      const pending = JSON.parse(raw);
      if (!pending?.key || !pending?.look) return;
      const saved = this.savedLooks();
      if (!saved.some((entry) => entry.key === pending.key)) saved.push(pending);
      localStorage.setItem('goodElevationSavedLooks', JSON.stringify(saved.slice(-30)));
      localStorage.removeItem('goodElevationPendingSavedLook');
      document.dispatchEvent(new CustomEvent('goodElevationSavedLooksChanged'));
    } catch (_) {}
  }

  showSaveLoginPrompt() {
    let modal = document.querySelector('[data-ge-save-login-modal]');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'ge-save-login';
      modal.setAttribute('data-ge-save-login-modal', '');
      modal.innerHTML = `
        <button type="button" class="ge-save-login__backdrop" data-ge-save-login-close aria-label="Close"></button>
        <div class="ge-save-login__dialog" role="dialog" aria-modal="true" aria-labelledby="ge-save-login-title">
          <button type="button" class="ge-save-login__close" data-ge-save-login-close aria-label="Close">×</button>
          <h2 id="ge-save-login-title">Save your look</h2>
          <p>Sign in to save this look and access it anytime.</p>
          <a class="ge-save-login__button" data-ge-save-login-link>SIGN IN</a>
        </div>`;
      document.body.appendChild(modal);
      modal.addEventListener('click', (event) => {
        if (event.target.closest('[data-ge-save-login-close]')) modal.hidden = true;
      });
    }
    const link = modal.querySelector('[data-ge-save-login-link]');
    const returnUrl = `${window.location.pathname}${window.location.search}`;
    const joiner = this.loginUrl.includes('?') ? '&' : '?';
    link.href = `${this.loginUrl}${joiner}return_url=${encodeURIComponent(returnUrl)}`;
    modal.hidden = false;
  }

  updateSaveButton() {
    if (!this.saveButton) return;
    const saved = this.savedLooks().some((entry) => entry.key === this.lookKey());
    this.saveButton.classList.toggle('is-saved', saved);
    this.saveButton.setAttribute('aria-pressed', saved ? 'true' : 'false');
    this.saveButton.querySelector('[data-ge-save-label]').textContent = saved ? 'Saved' : 'Save look';
    this.saveButton.querySelector('[data-ge-save-icon]').textContent = saved ? '♥' : '♡';
  }

  toggleWhy() {
    if (!this.whyPanel) return;
    this.whyPanel.hidden = false;
    this.whyButton?.setAttribute('aria-expanded', 'true');
    this.whyPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  async addCompleteLook(buyNow = false) {
    const look = this.looks[this.currentLookIndex];
    const products = Array.isArray(look?.products) ? look.products : [];
    const boxId = `GE-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

    const items = products
      .filter((product) => Number(product.variant_id) > 0)
      .map((product) => ({
        id: Number(product.variant_id),
        quantity: 1,
        properties: {
          '_Good Elevation Box': boxId,
          '_Complete Styling Box': 'Yes',
          '_Recommended Look': String(this.currentLookIndex + 1)
        }
      }));

    if (items.length < 1) {
      this.setStatus('This complete outfit is not currently available to add to cart.');
      return;
    }

    const actionButton = buyNow ? this.buyNowButton : this.addButton;
    actionButton?.setAttribute('aria-busy', 'true');
    if (this.addButton) this.addButton.disabled = true;
    if (this.buyNowButton) this.buyNowButton.disabled = true;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('Cart request failed.');
      window.GoodElevationAnalytics?.track('add_to_cart', {
        look_index: this.currentLookIndex + 1,
        item_count: items.length,
        box_id: boxId
      });
      this.setStatus(buyNow ? 'Taking you to secure checkout…' : 'Your Good Elevation outfit has been added to the cart.');
      document.dispatchEvent(
        new CustomEvent('good-elevation:look-added', { detail: { items } })
      );
      if (buyNow) {
        window.GoodElevationAnalytics?.track('checkout_started', {
          look_index: this.currentLookIndex + 1,
          item_count: items.length,
          box_id: boxId
        });
        window.location.href = `${root}checkout`;
        return;
      }
    } catch (error) {
      console.error('[Good Elevation cart]', error);
      this.setStatus('We could not add this complete outfit to the cart. Please try again.');
    } finally {
      actionButton?.removeAttribute('aria-busy');
      if (this.addButton) this.addButton.disabled = false;
      if (this.buyNowButton) this.buyNowButton.disabled = false;
    }
  }

  setStatus(message) {
    if (this.status) this.status.textContent = message;
  }

  priceAmount(product) {
    if (product.price_zar != null) return Number(product.price_zar) || 0;
    if (product.price_amount != null) return Number(product.price_amount) || 0;

    const raw = product.price ?? product.variant_price ?? 0;
    if (typeof raw === 'string' && /[^0-9.,]/.test(raw)) {
      return Number(raw.replace(/[^0-9.,]/g, '').replace(/,/g, '')) || 0;
    }

    const numeric = Number(raw) || 0;
    return Number.isInteger(numeric) && numeric >= 10000 ? numeric / 100 : numeric;
  }

  compareAtAmount(product) {
    const raw =
      product.compare_at_price_zar ??
      product.compare_at_price_amount ??
      product.compare_at_price ??
      product.variant_compare_at_price ??
      0;

    if (typeof raw === 'string' && /[^0-9.,]/.test(raw)) {
      return Number(raw.replace(/[^0-9.,]/g, '').replace(/,/g, '')) || 0;
    }

    const numeric = Number(raw) || 0;
    return Number.isInteger(numeric) && numeric >= 10000 ? numeric / 100 : numeric;
  }

  productPrice(product) {
    return (
      product.price_formatted ||
      product.formatted_price ||
      this.formatMoney(this.priceAmount(product))
    );
  }

  formatMoney(amount, allowZero = false) {
    const numeric = Number(amount) || 0;
    if (!numeric && !allowZero) return 'Price at checkout';

    return new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency: this.currency || 'ZAR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
      .format(numeric)
      .replace('ZAR', 'R')
      .replace(/\s/g, '');
  }

  escape(value) {
    const node = document.createElement('div');
    node.textContent = String(value ?? '');
    return node.innerHTML;
  }

  safeUrl(value, allowExternal = false) {
    try {
      const parsed = new URL(String(value || '#'), window.location.origin);
      if (!['http:', 'https:'].includes(parsed.protocol)) return '#';
      if (!allowExternal && parsed.origin !== window.location.origin) return '#';
      return parsed.href;
    } catch (_) {
      return '#';
    }
  }
}

if (!customElements.get('good-elevation-ai-stylist')) {
  customElements.define('good-elevation-ai-stylist', GoodElevationAIStylist);
}
